"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPostMessage = exports.isWindowInIframe = void 0;
const isWindowInIframe = () => globalThis.self !== globalThis.top;
exports.isWindowInIframe = isWindowInIframe;
const getPostMessage = (origin) => (data) => {
    globalThis.parent.postMessage(data, origin);
};
exports.getPostMessage = getPostMessage;
//# sourceMappingURL=iframe.js.map